module.exports = __webpack_public_path__ + "static/media/au.8b3deb10.png";